export function resolveBundledAssetUrl(value) {
  if (value == null || value === "") {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    return "";
  }
  if (typeof value === "object") {
    if (typeof value.default === "string") {
      return value.default;
    }
    if (typeof value.default === "number") {
      return "";
    }
    if (value.default != null && typeof value.default === "object") {
      return resolveBundledAssetUrl(value.default);
    }
  }
  return "";
}
